{
  "uigAddToCart": {
    "addingProductToCart": "Adding #{{productCode}} to cart",
    "backendMessage": "Art.Nr.: {{productCode}} - {{errDescription}}",
    "itemsNotListedForUser": "Das Produkt ist für Sie nicht gelistet",
    "noStock": "Helaas hebben wij de hoeveelheid in uw winkelwagen niet op voorraad.",
    "removedItem": "Het product is succesvol verwijderd uit de winkelwagen."
  }
}
